<template>
  <transition
    v-if="$isStandard"
    name="fade"
    mode="out-in"
  >
    <div
      v-if="score >= 1 && !hide"
      class="brand-heading inline-flex select-none items-center rounded bg-gradient-to-b text-sm leading-none text-white"
      :class="getAchievementColor()"
      style="padding-top: 3px; padding-bottom: 3px; padding-left: 5px; padding-right: 5px"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="inline-block h-3 w-3"
        :class="score > 250 && score < 1000 ? 'text-gray-600' : 'text-gray-100'"
        style="margin-right: 4px"
        role="img"
        viewBox="0 0 576 512"
      >
        <path
          fill="currentColor"
          d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
        />
      </svg>
      {{ score }}
    </div>
  </transition>
</template>

<script>

export default {
  name: 'ScoreThing',
  props: {
    score: {
      type: Number,
      default: 0,
    },
    hide: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    getAchievementColor() {
      if (this.score < 250) {
        return 'achievement-bronze-bg';
      }
      if (this.score < 1000) {
        return 'from-gray-200 to-gray-400 text-gray-600';
      }
      return 'achievement-gold-bg';
    },
  },
};
</script>

<style>
.achievement-bronze-bg {
  background-image: linear-gradient(to bottom, #caaf85, #a08a69) !important;
}

.achievement-gold-bg {
  background-image: linear-gradient(to bottom, #e4c560, #d4af37) !important;
}
</style>
